import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PricingBlock from "./util/PricingBlock.jsx"
import { Helmet } from "react-helmet";
import "../scss/v2/pricing.scss"

function Pricing(props) {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(props.lang)
    }, [i18n, props.lang])

    return (
        <div className="pricing">
            <Helmet>
                <title>{t("meta.title.pricing")}</title>
                <meta name="description" content={t("meta.description.pricing")} />
            </Helmet>
            <PricingBlock headTitle />
        </div>
    )

}

export default Pricing